import { REQUEST_META_DATA_SUCCESS } from "../constants/metaDataConstants";

const initialState = {
  shiftTypesMetaData: [],
};

export const metaDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_META_DATA_SUCCESS:
      return {
        ...state,
        shiftTypesMetaData: action.payload,
      };
    default:
      return state;
  }
};
